<template>
    <div class="chart-container">
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time'
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.2 // Makes the line slightly curved
                    },
                    point: {
                        radius: 4,
                        hitRadius: 10,
                        hoverRadius: 6
                    }
                }
            })
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    }
}
</script>

<style>
.chart-container {
    position: relative;
}
</style>